import * as vp from 'vopay';
import React, { FunctionComponent, useMemo } from 'react';

import { createPortal } from 'react-dom';
import styles from './MiniModal.module.scss';

const { Modal, Button } = vp;

type MiniModalProps = {
  title: React.JSX.Element;
  content: React.JSX.Element;
  onClose: () => void;
  show: boolean;
};

type FC = FunctionComponent<MiniModalProps>;

const MiniModal: FC = ({ title, content, onClose, show }: MiniModalProps) =>
  useMemo(() => {
    const miniModalDialogue = (
      <>
        <div>
          {/* Agree PAD Agreement */}
          <Modal isVisible={show} enableBgClick={false}>
            <div className={styles.MiniModal}>
              <h2 className={styles.MiniModalHeader}>{title}</h2>
              <div className={styles.MiniModalContent}>{content}</div>

              <div className={styles.CrossContainer}>
                <Button
                  id='pre-authorized-debit-close"'
                  color="none"
                  label=""
                  iconLocation="center"
                  icon="cross"
                  iconSize="md"
                  iconWidth="13px"
                  iconHeight="13px"
                  background="none"
                  noShadow
                  onClick={() => {
                    onClose();
                  }}
                />
              </div>
            </div>
          </Modal>
        </div>
      </>
    );
    return createPortal(miniModalDialogue, document.getElementById('modal-root')!);
  }, [show]);

export default MiniModal;
